<template>
    <ContainerContent
        class="mb-8 mt-6"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Support</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ul>
                    <li>
                        <NuxtLink to="/support/register">Register New Product</NuxtLink>
                        <span class="ms-2">(required account)</span>
                    </li>
                    <li>
                        <NuxtLink to="/faq">Frequently Asked Questions</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink to="/order-status">Check Order Status</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink to="/support/contact">Contact Us</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink to="/support/returns">Returns</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink to="/support/warranty">Warranty Claim</NuxtLink>
                    </li>
                </ul>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Support | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Support'
            }
        ]
    });
</script>
